// extracted by mini-css-extract-plugin
module.exports = {"statusIcon":"SinkStatus_statusIcon__2Jhm8","success":"SinkStatus_success__uEC71","danger":"SinkStatus_danger__2jTN-","warning":"SinkStatus_warning__1wFNa"};